import(/* webpackMode: "eager" */ "/app/diamond-ui/src/app/dao/create/page.tsx");
